import React, { useEffect, useState } from "react";
import Layout1 from "../../DataLayouts/Layout1";
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import {
  deleteOrganizationRolePermissions,
  fetchOrganizationRolePermissions,
} from '../../../Apis/ApplicationManagementApis';
import toast from "react-hot-toast";
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import DescriptionIcon from '@mui/icons-material/Description';
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import useAuthStore from "../../../Zustand/Store/useAuthStore";

function RolePermissionList() {
  const [assignment, setAssignment] = useState([]);
  const [loading, setLoading] = useState(true);
  const { userData } = useAuthStore();
  const org = userData?.organization;

  const navigate = useNavigate();

  useEffect(() => {
    if (!org?.organization_id) {
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await fetchOrganizationRolePermissions(org.organization_id);
        const a = Array.isArray(res?.permissions)
          ? res.permissions
          : Array.isArray(res?.permissions?.data)
          ? res.permissions.data
          : [];

        const grouped = a.reduce((acc, curr) => {
          const roleId =
            curr.organization_user_role?.organization_user_role_id ??
            curr.organization_user_role_id;
          if (!roleId || acc[roleId]) {
            return acc;
          }
          acc[roleId] = {
            id: roleId,
            name:
              curr.organization_user_role?.user_role_name ??
              curr.organization_user_role?.role_name ??
              curr.application_user_role?.user_role_name,
          };
          return acc;
        }, {});

        const b = Object.values(grouped).map((item) => ({
          ...item,
          view: (
            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={() => navigate(`/application/user-role-permission/view/${item.id}`)}
            >
              View Permissions
            </Button>
          ),
        }));
        setAssignment(b);
      } catch (error) {
        console.log(error);
        toast.error("Failed to fetch role permissions");
      }
      setLoading(false);
    };

    fetchData();
  }, [navigate, org?.organization_id]);

  const deleteassignment = async (id) => {
    if (!org?.organization_id) {
      toast.error("Organization not found.");
      return;
    }

    try {
      await deleteOrganizationRolePermissions(org.organization_id, id);
      toast.success("Role permissions deleted successfully");
      
      // Refresh the list after deletion
      setAssignment((prev) => prev.filter((item) => item.id !== id));
    } catch (error) {
      console.error("Delete failed:", error);
      toast.error(error.response?.data?.error || "Failed to delete User Role Permission");
    }
  };

  return (
    <Layout1
      loading={loading}
      rowsPerPage={10}
      edit_action={"USER_ROLE_PERMISSION_EDIT"}
      delete_action={"USER_ROLE_PERMISSION_DELETE"}
      heading={"User Role Permissions"}
      btnName={"ADD ROLE PERMISSION"}
      Data={assignment}
      tableHeaders={[
        { name: "Role", value_key: "name", textStyle: "capitalize" },
        { name: "View", value_key: "view" },
      ]}
      Icons={[
        <FormatAlignJustifyIcon sx={{ fontSize: 60, color: "grey.500", mb: 2 }} />,
        <ViewModuleIcon color="primary" />,
        <DescriptionIcon sx={{ color: "text.secondary" }} />
      ]}
      messages={[
        " Role Permission",
        " Role Permission",
        "Add  Role Permission",
        "Role Permission"
      ]}
      Route={"/application/user-role-permission"}
      setData={setAssignment}
      DeleteFunc={deleteassignment}
    />
  );
}

export default RolePermissionList;